// extracted by mini-css-extract-plugin
export default {"chartAreaTop":"rgba(211,120,242,.25)","chartAreaBottom":"rgba(211,120,242,0)","chartStart":"#5a9cff","chartMiddle":"#d378f2","chartEnd":"#e28a9c"};